module.exports = __webpack_public_path__ + "static/img/name.17eb8b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/wxsjglm/name.png
// module id = m9hj
// module chunks = 7